import { useEffect, useRef } from "react";

/**
 * Runs a react effect on update only, not on initial render. In other words,
 * the effect only due to a change in one of the provided dependencies.
 *
 * @param {() => () => Any} updateEffect A react effect function.
 * @param {[Any]} dependencies The dependencies for the effect.
 *
 * @returns {void}
 */
const useUpdateEffect = (updateEffect, dependencies) => {
  const isInitialRender = useRef(true);
  useEffect(() => {
    if (isInitialRender.current) return;
    return updateEffect();
  }, dependencies);
  useEffect(() => {
    isInitialRender.current = false;
  }, []);
};

export default useUpdateEffect;
